import React from 'react';

const LearningReasonSelect = props => {
  const { learningReasonId, handleChange, learningReasons } = props;
  return (
    <select
      className="form-control btn-cursor"
      name="selectedReasonId"
      onChange={handleChange}
      value={learningReasonId}
      data-qa-id="onboard-learning-reason"
      required
    >
      <option value="">Select a reason</option>
      {
        learningReasons.map(reason => {
          return (<option value={reason.id} key={reason.id}>{reason.description}</option>)
        })
      }
    </select>
  );
};

export default LearningReasonSelect;



// WEBPACK FOOTER //
// ./src/pages/student/OnBoard/LanguageProfile/LearningReasonSelect/index.js